import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import { deleteRight, formatFormTitle } from "../../../util/breadcrumb";
import { StyledBreadCrumb } from "../../styled/Breadcrumbs";

const Breadcrumb = ({
  setForm,
  fields,
  form,
  setFields,
  setFromBread,
  disableNavigationBackwards,
}) => {

  function handleClick(e) {
    if (!disableNavigationBackwards) {
      setFields(deleteRight(fields, e));
      setForm(e);
      setFromBread();
    }
  }

  return (
    <Stack spacing={4}>
      <Breadcrumbs
        separator={
          <StyledBreadCrumb.Icon as={NavigateNextIcon} fontSize="small" />
        }
      >
        {fields.map((e, index) => {
          return (
            <StyledBreadCrumb.BreadCrumb
              key={index}
              selected={e === form}
            >
              <StyledBreadCrumb.Label
                onClick={() => handleClick(e)}
                disabled={disableNavigationBackwards && e !== form}
              >
                {formatFormTitle(e)}
              </StyledBreadCrumb.Label>
            </StyledBreadCrumb.BreadCrumb>
          );
        })}
      </Breadcrumbs>
    </Stack>
  );
};

export default Breadcrumb;
